import Vue from 'vue'
import {firstEnterUrl, isIOS} from '../api/global'
import router from '@router'

export {
  isWechatBrower,
  getAuthorizeUrl,
  getAuthorizeUrl2,
  cfgJsSdk,
  cfgJsSdkSetUrl,
  routeTo
}

function isWechatBrower () {
  let microMessenger = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
  return microMessenger && microMessenger.toString() === 'micromessenger'
}

function getAuthorizeUrl () {
  let appId = process.env.WX_API_ID
  let rUrl = window.encodeURIComponent(process.env.WX_AUTH_REDIRECT_URL)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&` +
    `redirect_uri=${rUrl}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
}

/**
 * 针对未登录的用户，进行openid的获取
 */
function getAuthorizeUrl2 () {
  let appId = process.env.WX_API_ID
  let rUrl = window.encodeURIComponent(process.env.WX_AUTH_REDIRECT_URL2)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&` +
    `redirect_uri=${rUrl}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
}

function routeTo (route) {
  if (isIOS) {
    let to = router.resolve(route)
    location.href = to.href
  } else {
    router.push(route)
  }
}

function cfgJsSdk (apiList, success, error) {
  let url = isIOS ? firstEnterUrl : location.href
  cfgJsSdkSetUrl(apiList, url, success, error)
}

function cfgJsSdkSetUrl (apiList, url, success, error) {
  if (Array.isArray(apiList)) apiList = apiList.join()
  let wx = Vue.wechat
  Vue.http.get('/api/wx/js_sdk_config', {params: {url, apiList}}).then(({body: {config}}) => {
    let cfg = JSON.parse(config)
    wx.config(cfg)
    if (success) {
      wx.ready(() => {
        success()
      })
    }
    if (error) {
      wx.error((res) => {
        error(res)
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/wx.js